<section>
  <div class="section-header">Academic Admission Requirements</div>
  <div class="p-3">
    <ng-container *ngIf="academicRequirements?.length > 0; else noAcademicRequirementsTemplate">
      <div class="form-check mb-2" *ngFor="let req of academicRequirements">
        <input class="form-check-input" type="checkbox" [disabled]="isViewStudent" [id]="req.academicPurposeTypeId"
          [(ngModel)]="req.selected">
        <label class="form-check-label" [for]="req.academicPurposeTypeId">
          {{ req.description }}
        </label>
      </div>
    </ng-container>
    <ng-template #noAcademicRequirementsTemplate>
      <div class="required no-data-found">No Academic Admission Requirements defined.</div>
    </ng-template>
  </div>
</section>
<section>
  <div class="section-header">Non-Academic Admission Requirements</div>
  <div class="p-3">
    <ng-container *ngIf="nonAcademicAdmissionRequirements?.length > 0; else noNonAcademicRequirementsTemplate">
      <div class="mb-2" *ngIf="nonAcademicAdmissionRequirements?.length > 0"><em>If English is not a student's first
          language, they must provide proof of English Competency (one of the following):</em></div>
      <div class="form-check mb-2" *ngFor="let req of nonAcademicAdmissionRequirements">
        <input class="form-check-input" [disabled]="isViewStudent" type="checkbox" [id]="req?.academicPurposeTypeId"
          [(ngModel)]="req.selected">
        <label class="form-check-label" [for]="req?.academicPurposeTypeId">
          {{ req?.description }}
        </label>
        <div *ngIf="req?.selected && req?.is_lrws" class="row mt-2 ms-1">
          <div class="col-6 col-md-3 mb-2">
            <label class="form-label" [for]="req?.academicPurposeTypeId">Read</label>
            <input type="number" [min]="0" step="any" class="form-control" [disabled]="isViewStudent"
              (change)="onScoreChange($event,req, 'read')" [(ngModel)]="req.scores.read" placeholder="Read score"
              [id]="req?.academicPurposeTypeId">
          </div>
          <div class="col-6 col-md-3 mb-2">
            <label class="form-label" [for]="req?.academicPurposeTypeId">Write</label>
            <input type="number" [min]="0" step="any" class="form-control" [disabled]="isViewStudent"
              (change)="onScoreChange($event, req, 'write')" [(ngModel)]="req.scores.write" placeholder="Write score"
              [id]="req?.academicPurposeTypeId">
          </div>
          <div class="col-6 col-md-3 mb-2">
            <label class="form-label" [for]="req?.academicPurposeTypeId">Speak</label>
            <input type="number" [min]="0" step="any" class="form-control" [disabled]="isViewStudent"
              (change)="onScoreChange($event, req, 'speak')" [(ngModel)]="req.scores.speak" placeholder="Speak score"
              [id]="req?.academicPurposeTypeId">
          </div>
          <div class="col-6 col-md-3 mb-2">
            <label class="form-label" [for]="req?.academicPurposeTypeId + '-Listen'">Listen</label>
            <input type="number" [min]="0" step="any" class="form-control" [disabled]="isViewStudent"
              (change)="onScoreChange($event, req, 'listen')" [(ngModel)]="req.scores.listen" placeholder="Listen score"
              [id]="req?.academicPurposeTypeId + '-Listen'">
          </div>
        </div>
        <!--<div *ngIf="req.selected && requiresSingleScore(req)" class="mt-2 ms-1" style="max-width: 220px;">
        <label class="form-label">Score</label>
        <input type="number" step="any" class="form-control" [(ngModel)]="req.value" placeholder="Enter score">
      </div>-->
      </div>
    </ng-container>
    <ng-template #noNonAcademicRequirementsTemplate>
      <div class="required no-data-found">No Non-Academic Admission Requirements defined.</div>
    </ng-template>
  </div>
</section>
<section>
  <div class="section-header">Additional Form Configuration</div>
  <div class="p-3 config-forms-container">
    <div *ngIf="selectedFormIds.length === 0">
      <div class="mb-3 col-12 col-md-8">
        <div class="d-flex align-items-center mb-2 gap-4">
          <select class="form-select" [disabled]="isViewStudent" [(ngModel)]="selectedFormId">
            <option [ngValue]="null">-- Select Form Configuration --</option>
            <option *ngFor="let config of formConfigs" [ngValue]="config?.id">{{ config?.formName }}</option>
          </select>
          <div class="d-flex gap-2">
            <button class="btn btn-primary form-config-btn" (click)="addFormDropdownFromSelect()" [disabled]="isViewStudent || !selectedFormId"><mat-icon fontIcon="add"></mat-icon></button>
            <button class="btn btn-primary form-config-btn" [disabled]="isViewStudent || selectedFormIds?.length <= 1"><mat-icon fontIcon="remove"></mat-icon></button>
          </div>
        </div>
        <!-- Show dynamic fields immediately when a form is selected from the dropdown (before clicking +) -->
        <div *ngIf="selectedFormId && getSelectedConfig(selectedFormId) as selectedConfig" class="mt-2">
          <app-dynamic-form-fields
            [fieldsConfig]="selectedConfig?.additionalInfo?.configurableFields"
            [admissionReqData]="getAdmissionReqDataForForm(selectedFormId)"
            (formValueChange)="onFormValueChange($event, selectedConfig)">
          </app-dynamic-form-fields>
        </div>
      </div>
      <div class="text-muted" *ngIf="!selectedFormId">No additional forms added.</div>
    </div>
    <div *ngFor="let formId of selectedFormIds; let i = index; trackBy: trackByIndex" class="mb-3 col-12 col-md-8">
      <div class="d-flex align-items-center mb-2 gap-4">
        <select [id]="'formConfigSelect-' + i" class="form-select" [disabled]="isViewStudent"
                [(ngModel)]="selectedFormIds[i]"
                (ngModelChange)="onFormSelectionChanged($event, i)">
          <option [ngValue]="null">-- Select Form Configuration --</option>
          <option *ngFor="let config of formConfigs" [ngValue]="config?.id" [disabled]="selectedFormIds.includes(config?.id) && selectedFormIds[i] !== config?.id">{{ config?.formName }}</option>
        </select>
        <div class="d-flex gap-2">
          <button class="btn btn-primary form-config-btn" (click)="addFormDropdown()" [disabled]="isViewStudent || selectedFormIds?.length >= formConfigs?.length"><mat-icon fontIcon="add"></mat-icon></button>
          <button class="btn btn-primary form-config-btn" (click)="removeFormDropdown(i)" [disabled]="isViewStudent || selectedFormIds?.length === 1"><mat-icon fontIcon="remove"></mat-icon></button>
        </div>
      </div>
      <div *ngIf="selectedFormIds[i] && getSelectedConfig(selectedFormIds[i]) as selectedConfig">
        <app-dynamic-form-fields [fieldsConfig]="selectedConfig?.additionalInfo?.configurableFields"
          [admissionReqData]="getAdmissionReqDataForForm(selectedFormIds[i])"
          (formValueChange)="onFormValueChange($event, selectedConfig)"></app-dynamic-form-fields>
      </div>
    </div>
  </div>
</section>